import { useTranslation } from 'react-i18next';
import { Duty } from './types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Icon } from '@sdb/planning-ui';

export default function TooltipContent({ notes = [], qualifications }: Duty) {
  const { t } = useTranslation('common');
  const validNotes = notes.filter(({ text }) => text?.trim());
  const hasNotes = Boolean(validNotes.length);
  const hasQualifications = Boolean(qualifications && qualifications.length);
  // const isNotFromBaseplan = !isFromBasePlan;
  const isNotFromBaseplan = false;
  const hasContent = hasNotes || hasQualifications || isNotFromBaseplan;

  if (hasContent) {
    return (
      <>
        {hasQualifications && (
          <TableRow>
            <TableCell style={{ fontSize: 0 }}>
              <Icon type="file-certificate" fontSize="small" />
            </TableCell>
            <TableCell>
              <div>
                <strong>{t('qualifications')}</strong>
              </div>
              {qualifications?.map(({ name, id }) => (
                <div key={id}>{name}</div>
              ))}
            </TableCell>
          </TableRow>
        )}
        {hasNotes && (
          <TableRow>
            <TableCell style={{ fontSize: 0 }}>
              <Icon type="comment" fontSize="small" />
            </TableCell>
            <TableCell>
              <div>
                <strong>{t('notes')}</strong>
              </div>
              {validNotes.map(({ text, createdOn }, i) => (
                <div key={text + (createdOn || i)}>{text}</div>
              ))}
            </TableCell>
          </TableRow>
        )}
      </>
    );
  }

  return null;
}
